









import {Component, Prop, Vue} from 'vue-property-decorator';
import BoxTile from '@/components/ui/BoxTile.vue';
import TextContent from '@/components/ui/TextContent.vue';

@Component({
  components: {
    TextContent,
    BoxTile
  },
})
export default class GoalsQuestionView extends Vue {

  @Prop()
  public id!: string;

  @Prop()
  public qid!: string;

  get language() {
    if (this.$store.state.lang === 'es')
      return 'lang2';
    return 'lang1';
  }

  get goalDetails() {
    return this.$store.getters.goalDetailById(this.id);
  }

  get question() {
    if (this.goalDetails && this.goalDetails.details &&
            this.goalDetails.details.promptGoalCards &&
            this.goalDetails.details.promptGoalCards.length) {
      const goalCard = this.goalDetails.details.promptGoalCards.find((value: any) => value.id.toString() === this.qid.toString());
      if (goalCard && goalCard.card) {
        return goalCard.card;
      }
      return null;
    }
    return null;
  }

  get snippets() {
    const question = this.question;
    if (question) {
      return question.snippets;
    }
    return [];
  }

}
